import Queue from 'helpers/queue';
import produce from 'immer';

const queueSaving = new Queue();

// Base guideline
export const baseGetGuideLine = () => {
  return {
    guideLine: [],
    isLoadingGuide: false,
  };
};

export const fetchGuideline = (actions, state) => {
  return produce(state, (draft) => {
    draft.isLoadingGuide = true;
  });
};

export const fetchGuidelineSuccess = (actions, state) => {
  return produce(state, (draft) => {
    draft.isLoadingGuide = false;
    draft.guideLine = actions.data;
  });
};

export const fetchGuidelineFailed = (actions, state) => {
  return produce(state, (draft) => {
    draft.isLoadingGuide = false;
  });
};

// Base guideline by role
export const baseGetGuideLineByRole = () => {
  return {
    guideLineByRole: [],
    isLoadingGuideByRole: false,
  };
};

export const fetchGuidelineByRole = (actions, state) => {
  return produce(state, (draft) => {
    draft.isLoadingGuideByRole = true;
  });
};

export const fetchGuidelineByRoleSuccess = (actions, state) => {
  return produce(state, (draft) => {
    draft.isLoadingGuideByRole = false;
    draft.guideLineByRole = actions.data;
  });
};

export const fetchGuidelineByRoleFailed = (actions, state) => {
  return produce(state, (draft) => {
    draft.isLoadingGuideByRole = false;
  });
};

// Base save guideline
export const baseSaveGuideline = () => {
  return {
    queueSaving: queueSaving.queue,
  };
};

export const saveGuideline = (actions, state) => {
  queueSaving.pushToQueue(actions.role);
  return produce(state, (draft) => {
    draft.queueSaving = queueSaving.queue;
  });
};

export const saveGuidelineSuccess = (actions, state) => {
  queueSaving.removeFromQueue(actions.role);
  return produce(state, (draft) => {
    draft.queueSaving = queueSaving.queue;
  });
};

export const saveGuidelineFailed = (actions, state) => {
  queueSaving.removeFromQueue(actions.role);
  return produce(state, (draft) => {
    draft.queueSaving = queueSaving.queue;
  });
};
